import { gql } from '@apollo/client'
import { query } from '@/service/apollo/client'

const getAccessoryDetail = () => query(
  gql`
    query {
      accessoryPage {
        banner {
          url
          alternativeText
        }
      }
    }
  `
)

const countAccessory = (filter = {}) => query(
  gql`
    query($filter: JSON) {
      accessoriesCount(where: $filter)
    }
  `, { filter }
)

const getAccessoryBySlug = (slug, sort) => query(
  // query (where: {brand: {slug: "${slug}"}}, sort: "${sortQuery}") {
  gql`
      query {
        accessories(where: {slug: "${slug}"}) {
          id
          name
          slug
          description
          isSoldOut
          image {
            id
            url
            alternativeText
          }
          sizes {
            id
            size
          }
          colors {
            id
            color
            colorTHA
          }
          categories {
            id
            name
            nameTHA
          }
          price
        }
      }
    `
)

const getAccessoryItem = (filter = {}, start = 0, limit = 10, sort = 'createdAt:desc') => query(
  // query (where: {brand: {slug: "${slug}"}}, sort: "${sortQuery}") {
  gql`
    query($filter: JSON) {
      accessories(where: $filter, start: ${start}, limit: ${limit}, sort: "${sort}") {
        id
        name
        slug
        image {
          id
          url
          alternativeText
        }
        colors {
          id
          color
          colorTHA
        }
        categories {
          id
          name
          nameTHA
        }
        price
      }
    }
  `, { filter }
)

export {
  getAccessoryDetail,
  getAccessoryItem,
  getAccessoryBySlug,
  countAccessory
}
